// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container {
  box-shadow: 0 3px 7px #26a9df33;
}

.card-container div:active p {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/auth/UserTypeCard.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".card-container {\n  box-shadow: 0 3px 7px #26a9df33;\n}\n\n.card-container div:active p {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
